import Loader from 'components/Layout/Loader';
import Modal from 'components/Layout/Modal';
import React from 'react';

const PreviewHallTicketPopup = ({ onHide, pdfUrl }) => {
  return (
    <Modal
      titleBesideClose="Preview Hall Ticket"
      onHide={onHide}
      fullscreen
      isTitleBorder
      isTitleVerticalCenter
    >
      {!pdfUrl ? (
        <Loader />
      ) : (
        <iframe
          src={pdfUrl}
          title="Hall Ticket Preview"
          width="100%"
          height="100%"
          style={{ border: 'none' }}
        />
      )}
    </Modal>
  );
};

export default PreviewHallTicketPopup;
